module.exports = __webpack_public_path__ + "81e970b03bc0c60b2706184a497e2885.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00001505.png
// module id = 1479
// module chunks = 0